import { call, put, takeLatest } from "redux-saga/effects";
import { onGetOrder, onGetOrderError, onGetOrderSuccess, onPostOrder, onPostOrderError, onPostOrderSuccess, onUpdateOrder, onUpdateOrderError, onUpdateOrderSuccess } from "../Store/Slices/orderSlice";
import { callOrderGetApi, callOrderPostApi, callOrderUpdateApi } from "../Context/orderApi";
import { error } from "jquery";
import { decryptAES } from "../Common/Axios/encrypt";
import { onSavePoints } from "../Store/Slices/cardDataSlice";

function* GetOrder(payload) {
  try {
    const getOrderResponse = yield call(callOrderGetApi, payload);
    if (getOrderResponse.httpStatusCode === "200") {
      yield put(
        onGetOrderSuccess({
          data: getOrderResponse.response,
          message: getOrderResponse.response,
        })
      );
    } else {
      yield put(
        onGetOrderError({
          data: getOrderResponse.response,
          message: getOrderResponse.errorMessage,
        })
      );
    }
  } catch (error) {
    const message = error?.response?.data?.ErrorMessage || "Something went wrong";
    const errorCode = error?.response?.data?.ErrorCode || error?.response?.data?.errorCode;
    yield put(onGetOrderError({ data: {}, message, status_code: error?.response?.data?.HttpStatusCode || 400, errorCode }));
  }
}
function* PostOrder({ payload }) {
  try {
    const postOrderResponse = yield call(callOrderPostApi, payload);
    if (postOrderResponse.httpStatusCode === "201") {
      yield put(
        onPostOrderSuccess({
          postData: postOrderResponse.response,
          message: postOrderResponse.errorMessage,
          status_code: postOrderResponse.httpStatusCode,
          errorCode: postOrderResponse?.errorCode,
        })
      );
    } else {
      yield put(
        onPostOrderError({
          data: postOrderResponse.response,
          message: postOrderResponse.errorMessage,
          status_code: postOrderResponse.httpStatusCode,
          errorCode: postOrderResponse?.errorCode,
        })
      );
    }
  } catch (error) {
    const errorCode = decryptAES(error?.response?.data)?.ErrorCode || decryptAES(error?.response?.data)?.errorCode;
    yield put(onPostOrderError({ data: {}, message: decryptAES(error?.response?.data)?.errorMessage, status_code: decryptAES(error?.response?.data)?.HttpStatusCode, errorCode }));
  }
}

function* UpdateOrder({ payload }) {
  try {
    // console.log("Update order payload when payment is being processed:", payload);
    const updateOrderResponse = yield call(callOrderUpdateApi, payload);
    if (updateOrderResponse.httpStatusCode === "201") {
      yield put(
        onUpdateOrderSuccess({
          data: updateOrderResponse.response,
          message: updateOrderResponse.errorMessage,
          status_code: updateOrderResponse.httpStatusCode,
          errorCode: updateOrderResponse?.errorCode,
        })
      );
    } else {
      yield put(
        onUpdateOrderError({
          data: updateOrderResponse.response,
          message: updateOrderResponse.errorMessage,
          status_code: updateOrderResponse.httpStatusCode,
          errorCode: updateOrderResponse?.errorCode,
        })
      );
      if (updateOrderResponse?.response?.points !== undefined && updateOrderResponse?.response?.points !== null && updateOrderResponse?.response?.points !== "") {
        yield put(
          onSavePoints({
            pointBalance: updateOrderResponse?.response?.points,
          })
        );
      }
    }
  } catch (error) {
    const message = decryptAES(error?.response?.data)?.errorMessage || "Something went wrong";
    const errorCode = decryptAES(error?.response?.data)?.ErrorCode || decryptAES(error?.response?.data)?.errorCode;
    yield put(onUpdateOrderError({ data: {}, message, status_code: decryptAES(error?.response?.data)?.HttpStatusCode || 400, errorCode }));
  }
}

export default function* OrderSaga() {
  yield takeLatest(onGetOrder.type, GetOrder);
  yield takeLatest(onPostOrder.type, PostOrder);
  yield takeLatest(onUpdateOrder.type, UpdateOrder);
}
